import React from 'react';

export const ArrowBackIcon = props =>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="9"
    viewBox="0 0 12 9"
    style={{
      fillRule: 'evenodd',
    }}
    {...props}
  >
    <path
      d="M206,861H195.716l3.29,3.29-0.716.716L194.284,861H194v-0.284l-0.006-.006L194,860.7V860.3l-0.006-.006,0.006-.006V860h0.284l4.006-4.006,0.716,0.716-3.29,3.29H206v1Z"
      transform="translate(-194 -856)"
    />
  </svg>;



// WEBPACK FOOTER //
// ./app/components/icons/arrow-back-icon.js